"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useWrapEvent_1 = __importDefault(require("@seaweb/coral/hooks/useWrapEvent"));
var useControlProp_1 = __importDefault(require("@seaweb/coral/hooks/useControlProp"));
function useTooltip(_a) {
    var activeProp = _a.active, _b = _a.initialActive, initialActive = _b === void 0 ? false : _b, onActiveChange = _a.onActiveChange, immediateProp = _a.immediate, _c = _a.initialImmediate, initialImmediate = _c === void 0 ? false : _c, onImmediateChange = _a.onImmediateChange, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onMouseDown = _a.onMouseDown, onFocus = _a.onFocus, onBlur = _a.onBlur, onKeyDown = _a.onKeyDown;
    var _d = __read(useControlProp_1.default(activeProp, initialActive, onActiveChange), 2), active = _d[0], setActive = _d[1];
    var _e = __read(useControlProp_1.default(immediateProp, initialImmediate, onImmediateChange), 2), immediate = _e[0], setImmediate = _e[1];
    react_1.useEffect(function () {
        if (!active) {
            setImmediate(false);
        }
    }, [active, setImmediate]);
    var rafRef = react_1.useRef(null);
    react_1.useEffect(function () { return function () {
        cancelAnimationFrame(rafRef.current);
    }; }, []);
    return {
        active: active,
        immediate: immediate,
        handlers: {
            onMouseEnter: useWrapEvent_1.default(onMouseEnter, function () { return setActive(true); }),
            onMouseLeave: useWrapEvent_1.default(onMouseLeave, function () { return setActive(false); }),
            onFocus: useWrapEvent_1.default(onFocus, function (e) {
                if (e.currentTarget.hasAttribute('data-focus-visible-added'))
                    setActive(true);
            }),
            onBlur: useWrapEvent_1.default(onBlur, function () { return setActive(false); }),
            onMouseDown: useWrapEvent_1.default(onMouseDown, function () {
                setImmediate(true);
                rafRef.current = requestAnimationFrame(function () { return setActive(false); });
            }),
            onKeyDown: useWrapEvent_1.default(onKeyDown, function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    setActive(false);
                    setImmediate(true);
                }
                else if (e.key === 'Escape') {
                    setActive(false);
                }
            }),
        },
    };
}
exports.default = useTooltip;
